export const globalVariables = {
    get limit() {
        return 8
    },
}
